import Divider from '@mui/material/Divider';

import { DecoratorOptionType } from '../../FilterBaseCDS.constants';

export const decoratorOptionValues = Object.values(DecoratorOptionType);

export const componentMap = {
  [DecoratorOptionType.DIVIDER]: Divider,
};
